(() => {
"use strict";
/* ── OFERTA (una sola fuente) · BOGO decidido por Joaco 11-oct: a mitad de camino entre la del desodorante y la del research ── */
/* Producto y descuentos propios verificados en Shopify. */
const VID = 67628464636086, TIENDA = "https://omba.com.es";
const ES_SHOPIFY = !!(window.Shopify && window.Shopify.shop), RUTA = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
const OFERTA = {1:{p:34.95,t:69.90,q:2,c:"PERIMENO1X1",lbl:"Pack 2x1 · 2 meses"},2:{p:54.95,t:139.80,q:4,c:"PERIMENO2X2",lbl:"Pack 4 meses"},3:{p:69.95,t:209.70,q:6,c:"PERIMENO3X3",lbl:"Pack 6 meses"}};
const CHECKOUT = (n, codes = [OFERTA[n].c]) => VID ? (ES_SHOPIFY ? `${RUTA}checkout?discount=${codes.join(",")}` : `${TIENDA}/cart/${VID}:${OFERTA[n].q}?discount=${codes.join(",")}`) : null;
const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
const mx = n => new Intl.NumberFormat("es-ES",{style:"currency",currency:"EUR"}).format(Math.round(n * 100) / 100);
let N = 2;

/* menú */
const menu = $("#siteNav"), menuToggle = $("#menuToggle");
const abrirMenu = on => { menu.hidden = !on; menuToggle.setAttribute("aria-expanded", String(on)); };
menuToggle.onclick = () => abrirMenu(menu.hidden);
$$("a", menu).forEach(a => a.onclick = () => abrirMenu(false));
document.addEventListener("click", e => { if (!menu.contains(e.target) && !menuToggle.contains(e.target)) abrirMenu(false); });

/* galería */
const TH = $$("#thumbs button");
const GAL_LABELS = TH.map(b => b.getAttribute("aria-label") || "OMBA Perimeno");
TH.forEach((b,i) => b.setAttribute("aria-label", `Ver imagen ${i + 1}: ${GAL_LABELS[i]}`));
const ver = i => { const j = (i + TH.length) % TH.length, b = TH[j]; $("#galMain").src = b.dataset.src; $("#galMain").alt = `OMBA Perimeno: ${GAL_LABELS[j]}`; TH.forEach(x => { x.classList.toggle("on", x === b); x.setAttribute("aria-current", String(x === b)); }); };
TH.forEach((b, i) => b.onclick = () => ver(i));
$$(".gal-main .nav").forEach(b => b.onclick = () => ver(TH.findIndex(x => x.classList.contains("on")) + +b.dataset.g));
ver(0);

/* acordeones */
$$(".acc>button").forEach((b,i) => {
  const panel = b.nextElementSibling;
  panel.id = `acordeon-${i + 1}`;
  b.setAttribute("aria-controls", panel.id);
  const actualizar = on => { b.parentElement.classList.toggle("on", on); b.setAttribute("aria-expanded", String(on)); panel.hidden = !on; };
  actualizar(b.parentElement.classList.contains("on"));
  b.onclick = () => actualizar(b.getAttribute("aria-expanded") !== "true");
});

/* packs */
function pick(n){ if (!OFERTA[n] || checkoutBusy) return; N = n; $$("#packs .pk").forEach(p => { const selected = +p.dataset.n === n; p.classList.toggle("on", selected); p.setAttribute("aria-checked", String(selected)); p.tabIndex = selected ? 0 : -1; }); $("#stickyName").textContent = n === 1 ? "2x1 · 2 meses" : OFERTA[n].lbl; $("#stickyP").textContent = mx(OFERTA[n].p); $("#stickyS").textContent = mx(OFERTA[n].t); pintarCarrito(); if (cartOpen) sincronizar(N).catch(mostrarError); }
$$("#packs .pk").forEach(p => {
  p.setAttribute("role", "radio");
  p.onclick = () => pick(+p.dataset.n);
  p.onkeydown = e => {
    const keys = ["ArrowLeft", "ArrowUp", "ArrowRight", "ArrowDown", "Home", "End"];
    if (!keys.includes(e.key)) return;
    e.preventDefault();
    const n = e.key === "Home" ? 1 : e.key === "End" ? 3 : ((N - 1 + (e.key === "ArrowLeft" || e.key === "ArrowUp" ? 2 : 1)) % 3) + 1;
    pick(n); $(`#packs .pk[data-n="${n}"]`).focus();
  };
});

/* fechas de entrega: 5 a 15 días hábiles */
(function(){
  const M = ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"];
  const habil = k => { const d = new Date(); let c = 0; while (c < k) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) c++; } return d; };
  const a = habil(5), b = habil(15);
  $$(".fenv").forEach(e => e.textContent = `entre el ${a.getDate()} ${M[a.getMonth()]} y el ${b.getDate()} ${M[b.getMonth()]}`);
})();

/* barra del slider de beneficios */
const sl = $("#slider");
sl.addEventListener("scroll", () => { const m = sl.scrollWidth - sl.clientWidth; $("#barI").style.left = (m ? sl.scrollLeft / m * 70 : 0) + "%"; }, {passive:true});

/* barra fija */
new IntersectionObserver(([e]) => $("#sticky").classList.toggle("on", !e.isIntersecting && e.boundingClientRect.top < 0)).observe($("#btnHero"));

/* carrito */
/* CARRITO_V8_RENDER_INICIO */
function pintarCarritoBase(){
  const o = OFERTA[N], ahorro = o.t - o.p, tope = N === 3;
  $("[data-lin-t]").textContent = o.lbl;
  $("[data-lin-s]").textContent = o.q + " frascos · 60 cápsulas cada uno";
  $("[data-gift]").textContent = "Guía digital gratis: Vuelve a sentirte tú";
  $("[data-lin-p]").textContent = mx(o.p);
  $("[data-total]").textContent = mx(o.p);
  $("[data-old]").textContent = mx(o.t);
  $("[data-savebox]").hidden = false;
  $("[data-savebox]").textContent = (o.q / 2) + (o.q === 2 ? " mes de regalo" : " meses de regalo");
  $("[data-nudge]").hidden = true;
  $("[data-tope]").hidden = true;
  if (!tope) {
    const nx = OFERTA[N + 1];
    $("[data-upt]").textContent = "Cubre " + nx.q + " meses por solo +" + mx(nx.p - o.p);
    $("[data-ups]").textContent = nx.q + " frascos · " + (nx.q / 2) + " meses de regalo";
  } else $("[data-tope-s]").textContent = "Te queda en " + mx(Math.round(o.p / o.q * 100) / 100) + " por mes de suministro";
  $("[data-prog-t]").textContent = "Tu regalo";
  $("[data-prog-e]").textContent = (o.q / 2) + (o.q === 2 ? " mes gratis" : " meses gratis");
  $("[data-prog-b]").style.width = Math.round(N / 3 * 100) + "%";
  $("[data-prog-g]").style.width = "0%";
  if (!checkoutBusy) $("#cGo").textContent = "Finalizar compra · " + mx(o.p);
  $("#cGo").disabled = checkoutBusy || !VID;
}
$("[data-nudge]").onclick = () => { if (N < 3) { pick(N + 1); if (N === 3) $("#editPack").focus({preventScroll:true}); } };
$("#editPack").onclick = () => { abrir(false); $("#packs .pk.on").focus({preventScroll:true}); $("#packs").scrollIntoView({behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",block:"center"}); };
$("#cartVideos").onclick = event => {
  const target = document.querySelector("#videos");
  if (!target) return;
  event.preventDefault();
  if (checkoutBusy) return;
  abrir(false);
  target.scrollIntoView({behavior:window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",block:"start"});
  const firstVideo = target.querySelector("button, a[href], [tabindex]");
  if (firstVideo) firstVideo.focus({preventScroll:true});
};
/* CARRITO_V8_RENDER_FIN */
/* CARRITO_CHECKOUT_INICIO */
/* Carrito Perimeno: patrón v8 del desodorante, insertado inline por _carrito_v8.py.
   Requiere VID, OFERTA, ES_SHOPIFY, RUTA, CHECKOUT, $, $$, mx, N, pick y pintarCarrito.
   pick bloquea cambios durante checkoutBusy y sincroniza cuando cartOpen.
   pintarCarrito conserva el texto de carga y disabled mientras checkoutBusy.
   Este archivo no llama pick(2): se inicializa después de insertar el runtime. */
let cartOpen = false, checkoutBusy = false, loadedQuantity = null,
    firstSync = true, queue = Promise.resolve(), previousFocus = null,
    previousOverflow = "", scrollLocks = [];
const cart = $("#cart"), cartError = $("#cartError"), checkoutButton = $("#cGo");
/* Complementarios opcionales pedidos por Joaquín, 19-oct-2026. */
const complementosV3=window.OMBAComplementosV3.attach({
  config:window.OMBAComplementosConfigV3["es-perimeno"],shopify:ES_SHOPIFY,root:document,request:cartRequest,
  parentQuantity:()=>OFERTA[N].q,parentTotalCents:()=>Math.round(OFERTA[N].p*100),
  busy:()=>checkoutBusy,enqueue:fn=>{const task=queue.then(fn);queue=task.catch(()=>{loadedQuantity=null;firstSync=true;});return task;}
});
function pintarCarrito(){pintarCarritoBase();complementosV3.render();}
function sincronizar(pack){return sincronizarBase(pack).then(()=>complementosV3.refresh());}

function reflejarOtrosProductos(current){
  const others = (current.items || []).some(item => Number(item.variant_id || item.id) !== VID);
  $("#cartOtherItems").hidden = !others;
  $("#cartTotalLabel").textContent = others ? "Este paquete" : "Total";
}

async function cartRequest(path, body, method = "POST"){
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await window.fetch(RUTA + path, {
      method,
      credentials: "same-origin",
      headers: {"Content-Type": "application/json", "Accept": "application/json"},
      ...(method === "GET" ? {cache: "no-store"} : {body: JSON.stringify(body || {})}),
      signal: controller.signal
    });
    const data = await response.json();
    if (!response.ok){
      const error = new Error(typeof data.description === "string" ? data.description : "No hemos podido actualizar tu carrito.");
      error.status = response.status;
      throw error;
    }
    return data;
  } finally {
    clearTimeout(timeout);
  }
}

function sincronizarBase(pack){
  if (!VID || !OFERTA[pack]) return Promise.reject(new Error("No hemos podido identificar tu paquete."));
  // En la vista local, el permalink llena el carrito al abrir Shopify.
  if (!ES_SHOPIFY) return Promise.resolve();
  const q = OFERTA[pack].q;
  const task = queue.then(async () => {
    if (loadedQuantity === q) return;
    if (firstSync){
      const current = await cartRequest("cart.js", undefined, "GET");
      const own = (current.items || []).filter(item => Number(item.variant_id || item.id) === VID);
      reflejarOtrosProductos(current);
      // Normaliza solo las líneas de Perimeno, incluidas las que tengan propiedades.
      if (own.length){
        const remove = {};
        own.forEach(item => { remove[item.key] = 0; });
        await cartRequest("cart/update.js", {updates: remove});
      }
      const added = await cartRequest("cart/add.js", {items: [{id: VID, quantity: q}]});
      if (!added.items || !added.items.some(item => Number(item.variant_id || item.id) === VID && Number(item.quantity) === q)){
        throw new Error("No hemos podido confirmar tu paquete. Inténtalo otra vez.");
      }
      firstSync = false;
    } else {
      const changed = await cartRequest("cart/update.js", {updates: {[VID]: q}});
      const actual = (changed.items || [])
        .filter(item => Number(item.variant_id || item.id) === VID)
        .reduce((sum, item) => sum + Number(item.quantity), 0);
      if (actual !== q) throw new Error("No hemos podido confirmar tu paquete. Inténtalo otra vez.");
      reflejarOtrosProductos(changed);
    }
    loadedQuantity = q;
    cartError.hidden = true;
  });
  // Un fallo o timeout no rompe la cola. El reintento vuelve a leer el carrito real.
  queue = task.catch(() => { loadedQuantity = null; firstSync = true; });
  return task;
}

async function descuentosCarrito(pack){
  if (!ES_SHOPIFY) return [OFERTA[pack].c];
  const current = await cartRequest("cart.js", undefined, "GET"), quantities = {};
  (current.items || []).forEach(item => {
    const id = item.variant_id || item.id;
    quantities[id] = (quantities[id] || 0) + Number(item.quantity);
  });
  reflejarOtrosProductos(current);
  if (quantities[VID] !== OFERTA[pack].q){
    loadedQuantity = null;
    firstSync = true;
    const error = new Error("El carrito cambió. Reintenta para confirmar tu paquete.");
    error.code = "CART_CHANGED";
    throw error;
  }
  const codes=window.OMBACartRegistry.codes(current);
  await cartRequest("cart/update.js", {discount: codes.join(",")});
  return codes;
}

function destinoCheckout(pack, codes){
  const destination = CHECKOUT(pack, codes);
  if (!destination) throw new Error("No hemos podido preparar el pago.");
  const url = new URL(destination, window.location.href);
  const incoming = new URLSearchParams(window.location.search);
  incoming.forEach((value, key) => {
    if (/^utm_/.test(key) || ["fbclid", "gclid", "ttclid"].includes(key)){
      url.searchParams.set(key, value);
    }
  });
  url.searchParams.set("discount", codes.join(","));
  return url.href;
}

function mostrarError(error){
  cartError.hidden = false;
  cartError.textContent = error && error.status === 422
    ? "Paquete no disponible. Elige otro o contáctanos."
    : error && error.code === "CART_CHANGED"
      ? "Tu carrito cambió. Pulsa Finalizar compra para confirmar de nuevo tu paquete."
      : "No hemos podido actualizar el carrito. Revisa tu conexión y pulsa Finalizar compra para reintentar.";
}

function bloquearCompra(busy){
  checkoutBusy = busy;
  checkoutButton.disabled = busy || !VID;
  checkoutButton.setAttribute("aria-busy", String(busy));
  $("[data-nudge]").disabled = busy;
  $("#editPack").disabled = busy;
  $$("#packs .pk").forEach(button => { button.disabled = busy; });
}

function abrir(on){
  if (on === cartOpen) return;
  if (on){
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    if (typeof abrirMenu === "function") abrirMenu(false);
    // Horizon desplaza .page-wrapper; la vista local usa el documento.
    scrollLocks = [...new Set([document.documentElement, document.querySelector(".page-wrapper")])]
      .filter(Boolean)
      .map(element => ({element, overflow: element.style.overflow}));
    document.body.style.overflow = "hidden";
    scrollLocks.forEach(({element}) => { element.style.overflow = "hidden"; });
  }
  cartOpen = on;
  document.body.classList.toggle("cart-open", on);
  cart.classList.toggle("on", on);
  $("#scrim").classList.toggle("on", on);
  cart.setAttribute("aria-hidden", String(!on));
  cart.inert = !on;
  $$("[data-open-cart]").forEach(button => button.setAttribute("aria-expanded", String(on)));
  if (on){
    pintarCarrito();
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (cartOpen) $("#closeCart").focus({preventScroll: true});
    }));
    sincronizar(N).catch(mostrarError);
  } else {
    document.body.style.overflow = previousOverflow;
    scrollLocks.forEach(({element, overflow}) => { element.style.overflow = overflow; });
    scrollLocks = [];
    if (previousFocus && previousFocus.isConnected) previousFocus.focus({preventScroll: true});
  }
}

if (!cart.hasAttribute("tabindex")) cart.setAttribute("tabindex", "-1");
$$("[data-open-cart]").forEach(button => {
  button.setAttribute("aria-controls", "cart");
  button.setAttribute("aria-expanded", "false");
  button.onclick = () => abrir(true);
});
$("#closeCart").onclick = $("#scrim").onclick = () => abrir(false);
$("[data-nudge]").onclick = () => {
  if (checkoutBusy || N >= 3) return;
  pick(N + 1);
  if (N === 3) $("#editPack").focus({preventScroll: true});
};
$("#editPack").onclick = () => {
  if (checkoutBusy) return;
  abrir(false);
  $("#packs").scrollIntoView({
    behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
    block: "center"
  });
  $("#packs .pk.on").focus({preventScroll: true});
};
document.addEventListener("keydown", event => {
  if (!cartOpen){
    const siteMenu = $("#siteNav");
    if (event.key === "Escape" && siteMenu && !siteMenu.hidden && typeof abrirMenu === "function"){
      event.preventDefault();
      abrirMenu(false);
      const toggle = $("#menuToggle");
      if (toggle) toggle.focus({preventScroll: true});
    }
    return;
  }
  if (event.key === "Escape"){
    event.preventDefault();
    abrir(false);
    return;
  }
  if (event.key !== "Tab") return;
  const focusable = $$("button:not([disabled]),a[href],input:not([disabled]),[tabindex='0']", cart)
    .filter(element => element.getClientRects().length);
  const first = focusable[0], last = focusable[focusable.length - 1];
  if (!first){ event.preventDefault(); cart.focus(); return; }
  if (!cart.contains(document.activeElement)){
    event.preventDefault();
    (event.shiftKey ? last : first).focus();
  } else if (event.shiftKey && document.activeElement === first){
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last){
    event.preventDefault();
    first.focus();
  }
});

checkoutButton.onclick = async () => {
  if (checkoutBusy || !VID) return;
  bloquearCompra(true);
  checkoutButton.textContent = "Preparando tu compra…";
  cartError.hidden = true;
  const pack = N;
  try {
    await sincronizar(pack);
    await complementosV3.beforeCheckout();
    const codes = await descuentosCarrito(pack);
    window.location.assign(destinoCheckout(pack, codes));
  } catch (error){
    bloquearCompra(false);
    pintarCarrito();
    mostrarError(error);
  }
};
window.addEventListener("pageshow", () => {
  loadedQuantity = null;
  firstSync = true;
  bloquearCompra(false);
  pintarCarrito();
});

/* CARRITO_CHECKOUT_FIN */
/* VIDEOS_ORIGINALES: una sola reproducción al tocar, con origen visible. */
const lb = $("[data-lb]"), lbv = $("video", lb), lbc = $("[data-lbcap]");
let videoTrigger = null, videoScroll = "";
const lbClose = () => { lbv.pause(); lbv.removeAttribute("src"); lbv.load(); lb.hidden = true; document.body.style.overflow = videoScroll; if(videoTrigger) videoTrigger.focus({preventScroll:true}); };
$$(".uv").forEach(b => b.onclick = () => { videoTrigger = b; videoScroll = document.body.style.overflow; lbv.src = b.dataset.video; lbc.textContent = b.dataset.cap; { const o = /omba-perimeno-video-/.test(b.dataset.video); $("#videoDialogTitle", lb).textContent = o ? "OMBA Perimeno · Vídeo" : "Snap Perimeno Health · Vídeo"; $(".lb-source", lb).innerHTML = o ? "Vídeo de OMBA interpretado por actriz." : "Contenido publicitario de Snap Perimeno Health.<br>Las experiencias corresponden a ese producto."; } lb.hidden = false; document.body.style.overflow = "hidden"; $("[data-lbclose]").focus(); lbv.play().catch(() => {}); });
$("[data-lbclose]").onclick = lbClose;
lb.addEventListener("click", ev => { if (ev.target === lb) lbClose(); });
lb.addEventListener("keydown", ev => { if(ev.key!=="Tab") return; const close=$("[data-lbclose]"); if(ev.shiftKey && document.activeElement===close){ev.preventDefault();lbv.focus();} else if(!ev.shiftKey && document.activeElement===lbv){ev.preventDefault();close.focus();} });
document.addEventListener("keydown", ev => { if (ev.key === "Escape" && !lb.hidden) lbClose(); });
pick(2);
})();
